import CityPageTemplate from "../city-template/CityPageTemplate";
import { tracyConfig } from "./data";

export default function TracyPage() {
  return <CityPageTemplate config={tracyConfig} />;
}